// extracted by mini-css-extract-plugin
module.exports = {"Platforms":"Platforms_Platforms__2sVT2"};